import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILookup } from '../../common/interfaces/ILookup.interface';
import { HttpClient } from '@angular/common/http';
import { SyntaxCheckResponse } from '../cpq-formula-builder.model';
import { PreviewTableData } from './table-list-tag-builder.model';
import { TranslationService } from '../../common/services/translation.service';
import { UrlPrefix } from "../../common/constants/url-prefix.constants";

@Injectable()
export class TableListTagService {
    constructor(private http: HttpClient, private translationService: TranslationService) { }

    public getTableNames(): Observable<Array<ILookup>> {
        return this.http.get<Array<ILookup>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/tables`);
    }

    public getColumnNames(tableName: string): Observable<Array<ILookup>> {
        return this.http.get<Array<ILookup>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/tables/columns?tableName=${tableName}`);
    }

    public testFormula(formula: string, isTableTag: boolean): Observable<SyntaxCheckResponse> {
        return this.http.post<SyntaxCheckResponse>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/tables?isTableTag=${isTableTag}`, JSON.stringify(formula));
    }

    public getPreviewDataTable(tableName: string): Observable<Array<PreviewTableData>> {
        return this.http.get<Array<PreviewTableData>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/tables/preview?tableName=${tableName}`);
    }

    public getNumericAndDateOperations(hasMatchingOperations: boolean): Array<ILookup<number, string>> {
        const numericDateOperations: Array<ILookup<number, string>> = [
            { id: 1, text: '=' },
            { id: 2, text: '>' },
            { id: 3, text: '>=' },
            { id: 4, text: '<' },
            { id: 5, text: '<=' }
        ];
        
        if (!hasMatchingOperations) {            
            numericDateOperations.push(...this.getMatchingOperations());
        }

        return numericDateOperations;
    }

    public getMatchingOperations(): Array<ILookup<number, string>> {
        const matchingOperations: Array<ILookup<number, string>> = [
            { id: 9, text: this.translationService.translate('TableBuilderAspx_MatchLowerStringConstant') },
            { id: 10, text: this.translationService.translate('TableBuilderAspx_MatchLowerInclusiveStringConstant') },
            { id: 11, text: this.translationService.translate('TableBuilderAspx_MatchUpperStringConstant') },
            { id: 12, text: this.translationService.translate('TableBuilderAspx_MatchUpperInclusiveStringConstant') },
        ];

        return matchingOperations;
    }

    public getTextOperations(): Array<ILookup<number, string>> {
        const textOperations: Array<ILookup<number, string>> = [
            { id: 1, text: '=' },
            { id: 6, text: this.translationService.translate('TableBuilderAspx_BeginsWithStringConstant') },
            { id: 7, text: this.translationService.translate('TableBuilderAspx_EndsWithStringConstant') },
            { id: 8, text: this.translationService.translate('TableBuilderAspx_MatchesStringConstant') },
        ];

        return textOperations;
    }

    public getColumnTypes(): Array<ILookup<number, string>> {
        const columnTypes: Array<ILookup<number, string>> = [
            { id: 1, text: this.translationService.translate('TableBuilderAspx_TextColumnTypeStringConstant') },
            { id: 2, text: this.translationService.translate('TableBuilderAspx_NumberColumnTypeStringConstant') },
            { id: 3, text: this.translationService.translate('TableBuilderAspx_DateColumnTypeStringConstant') }
        ];

        return columnTypes;
    }

    public getSortTypes(): Array<ILookup<number, string>> {
        const sortTypes: Array<ILookup<number, string>> = [
            { id: 1, text: this.translationService.translate('TableBuilderAspx_NoneStringConstant') },
            { id: 2, text: this.translationService.translate('TableBuilderAspx_AscendingStringConstant') },
            { id: 3, text: this.translationService.translate('TableBuilderAspx_DescendingStringConstant') }
        ];

        return sortTypes;
    }

    public getReturnTypes(): Array<ILookup<number, string>> {
        const returnTypes: Array<ILookup<number, string>> = [
            { id: 1, text: this.translationService.translate('TableBuilderAspx_ExactConstant') },
            { id: 2, text: this.translationService.translate('TableBuilderAspx_MinStringConstant') },
            { id: 3, text: this.translationService.translate('TableBuilderAspx_MaxStringConstant') },
            { id: 4, text: this.translationService.translate('TableBuilderAspx_CountStringConstant') },
            { id: 5, text: this.translationService.translate('TableBuilderAspx_AverageStringConstant') },
            { id: 6, text: this.translationService.translate('TableBuilderAspx_SumStringConstant') },
        ];

        return returnTypes;
    }
}


